import { connect } from 'react-redux';
import RegionAssignment from './RegionAssignment';
import { getStates, getCountiesByState, assignLenderLogisticsManagerToStates, assignLenderLogisticsManagerToCounties } from 'actions/region';
import * as employeeRoles from 'typeConstants/employeeRoles';

const mapStateToProps = (state) => {
  return {
    states: state.region.states,
    counties: state.region.countiesByState,
    isFetchingStates: state.region.isFetchingStates,
    isFetchingCounties: state.region.isFetchingCountiesByState,
    cardTitle: "Assign Lender Logistics Manager Region", 
    employeeRoles: [employeeRoles.LENDER_LOGISTICS_MANAGER, employeeRoles.FIELD_OPERATIONS_DIRECTOR, employeeRoles.FIELD_OPERATIONS_AVP],
    disableCountySelect: false,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getStates() {
    dispatch(getStates());
  },
  assignStates(request) {
    dispatch(assignLenderLogisticsManagerToStates(request));
  },
  getCountiesByState(states) {
    dispatch(getCountiesByState(states));
  },
  assignCounties(request) {
    dispatch(assignLenderLogisticsManagerToCounties(request));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(RegionAssignment);
